import React, { useContext, useRef, useState } from 'react';
import { MainViewContext } from '../../../Pages/MainComponents/MainView/MainViewContext';
import { TransitionAction } from '../../../Pages/MainComponents/MainView/MainViewModel';
import LocalStorageService from '../../../Services/LocalStorageService';
import { withTracking } from '../../../Services/Monitoring/ApplicationInsights';
import CompletedWorkflowService from '../../../Utils/CompletedWorkflow';
import { IDialogContentProps } from '../DialogUtils';
import { MenuDialogType } from '../Menu/MenuDialogType';
import RedoHLAABeepConfirmation from './BeepConfirmation/RedoHLAABeepConfirmation';
import RedoHLAADialog from './Dialog/RedoHLAADialog';
import RedoHLAAOneSideSetUp from './OneSideSetUp/RedoHLAAOneSideSetUp';
import {
    infoType,
    IRedoHLAAContext,
    RedoHLAAContext,
    RedoHLAAState,
} from './RedoHLAAContext';
import SleeveSelection from '../SleeveSelection/SleeveSelection';
import RedoHLAATechnicalSetup from './TechnicalSetup/RedoHLAATechnicalSetup';
import RedoHLAATroubleShooting from './TroubleShooting/RedoHLAATroubleShooting';

function RedoHLAAPage({ onClose }: IDialogContentProps) {
    const [redoHLAAState, setRedoHLAAState] = useState<RedoHLAAState>(
        RedoHLAAState.Start
    );
    const viewContext = useContext(MainViewContext);

    const workflow = LocalStorageService.serviceInstance.getCompletedWorkflow();

    const createContextInfo = (): infoType => {
        return {
            activeSide: 'left',
            totalPageCount: 0,
            totalPagesForProgress: 4,
        };
    };

    const info = useRef<infoType>(createContextInfo());

    const initialValue: IRedoHLAAContext = {
        info: info,
        redoHLAAState: redoHLAAState,
        setRedoHLAAState: setRedoHLAAState,
    };
    const renderSwitch = (state: RedoHLAAState) => {
        switch (state) {
            case RedoHLAAState.Start: {
                return (
                    <RedoHLAADialog
                        onClose={
                            CompletedWorkflowService.isCompletedMandatoryWorkflow(
                                workflow
                            )
                                ? () =>
                                      viewContext.doTransition(
                                          TransitionAction.SkipRedoHLAA
                                      )
                                : onClose
                        }
                        key={MenuDialogType.RedoHLAA}
                        onPrimaryAction={() =>
                            setRedoHLAAState(RedoHLAAState.TechnicalSetup)
                        }
                    />
                );
            }
            case RedoHLAAState.TechnicalSetup: {
                return <RedoHLAATechnicalSetup />;
            }
            case RedoHLAAState.OneSideSetUp: {
                return <RedoHLAAOneSideSetUp />;
            }
            case RedoHLAAState.BeepConfirmation: {
                return <RedoHLAABeepConfirmation onClose={onClose} />;
            }
            case RedoHLAAState.SleeveSelection: {
                return <SleeveSelection onClose={onClose} />;
            }
            case RedoHLAAState.TroubleShooting: {
                return <RedoHLAATroubleShooting />;
            }
        }
    };

    return (
        <RedoHLAAContext.Provider value={initialValue}>
            {renderSwitch(redoHLAAState)}
        </RedoHLAAContext.Provider>
    );
}

export default withTracking(RedoHLAAPage);
